<template>
  <FacilitatorTab :surveys="facilitatorSurveys"></FacilitatorTab>
</template>

<script>
import { mapGetters } from "vuex";

import FacilitatorTab from "@/components/project/FacilitatorTab.vue";

export default {
  components: {
    FacilitatorTab
  },
  props: {
    projectSummary: { type: Object, required: true }
  },
  data() {
    return {

    }
  },
  computed: {
    ...mapGetters({
      isLoading: 'getDataLoading',
      hasLoaded: 'getDataLoaded',
    }),
    facilitatorSurveys() {
      return this.projectSummary.facilitatorSurveys;
    },
  },
  watch: {
  },
  mounted() {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>

</style>
